// App.js
// Main app component
// Handles URL params for crossover report new-tab mode:
//   ?watchlist=123&jumpDate=2026-01-15&showVPatterns=1

import React, { useEffect } from 'react';
import Dashboard from './components/Dashboard';
import useStore   from './store';
import './App.css';
import Login from './components/Login';
import { setApiToken } from './api';
import { fetchWatchlistStocks } from './api';

function App() {
  const {
    setUrlParams,
    setShowVPatterns,
    setVpFilters,
    setChartSetting,
    setMarkersConfig,
    setWatchlist,
    setSelectedSymbol,
    setJumpTrigger,
  } = useStore();

  const token = useStore((s) => s.token);

  useEffect(() => {
    const stored = localStorage.getItem('trading_token');
    if (stored) setApiToken(stored);

    const params      = new URLSearchParams(window.location.search);
    const watchlistId = params.get('watchlist');
    const jumpDate    = params.get('jumpDate');
    const showVP      = params.get('showVPatterns');
    const vpEma       = params.get('vpEma');
    const vpFromDate  = params.get('vpFromDate');
    const vpToDate    = params.get('vpToDate');
    const vpTimeframe = params.get('vpTimeframe');

    
    if (watchlistId) {
      fetchWatchlistStocks(watchlistId)
        .then(stocks => {
          const symbols = (stocks || []).map(s => s.symbol);
          if (symbols.length > 0) {
            setWatchlist(symbols);
            setSelectedSymbol(symbols[0]);
            if (jumpDate) {
              setTimeout(() => setJumpTrigger(jumpDate), 1500);
            }
          }
        })
        .catch(console.error);
    }

    if (showVP === '1') {
      setShowVPatterns(true);
      setVpFilters({
        ema:          vpEma        || null,
        fromDate:     vpFromDate   || null,
        toDate:       vpToDate     || null,
        timeframe:    vpTimeframe  || null,
        direction:    params.get('vpDirection') || null,
        max_gap:      params.get('vpMaxGap')       != null ? Number(params.get('vpMaxGap'))       : null,
        min_inter_gap:params.get('vpMinInterGap')  != null ? Number(params.get('vpMinInterGap'))  : null,
        trend_confirmed: params.get('vpTrend')      === 'yes' ? true : params.get('vpTrend')      === 'no' ? false : null,
        close_rising:    params.get('vpCloseTrend') === 'yes' ? true : params.get('vpCloseTrend') === 'no' ? false : null,
        ema_rising:      params.get('vpEmaTrend')   === 'yes' ? true : params.get('vpEmaTrend')   === 'no' ? false : null,
        confirm_break:   params.get('vpConfirmBreak') || null,
      });
      if (vpTimeframe) {
        
        setChartSetting(0, 'timeframe', vpTimeframe);
      }
      if (vpEma) {
        setChartSetting(0, 'visibleEMAs', {
          ema_5: false, ema_9: false, ema_20: false,
          ema_50: false, ema_200: false,
          [vpEma]: true,
        });
      }
    }

    // Read markers config saved by report Charts button
    const savedMarkers = sessionStorage.getItem('markersConfig');
    if (savedMarkers) {
      try {
        const cfg = JSON.parse(savedMarkers);
        setMarkersConfig(cfg);
        sessionStorage.removeItem('markersConfig');
      } catch (_) {}
    }

    // Read chart settings saved by report Charts button
    const savedChartSettings = sessionStorage.getItem('reportChartSettings');
    if (savedChartSettings) {
      try {
        const cfg = JSON.parse(savedChartSettings);
        if (cfg.timeframe) {
          setChartSetting(0, 'timeframe', cfg.timeframe);
        }
        if (cfg.visibleEMAs) {
          setChartSetting(0, 'visibleEMAs', cfg.visibleEMAs);
        }
        sessionStorage.removeItem('reportChartSettings');
      } catch (_) {}
    }

  }, []);

  if (!token) {
    return <Login />;
  }

  return (
    <div className="App">
      <Dashboard />
    </div>
  );
}

export default App;